import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import userService from './user/UserService';
import { authorizedPost } from './api-authorization/AuthorizedFetch';
import { StyledButton } from './shared/styled';
import { safeParseResponse } from '../utils';

// newtodo - there are too many newcheckinforms instantiated but not open, maybe move the isopen outside of it?
export const NewCheckInFormButton = ({ defaultClass, children }) => {
  const [modalState, setModalState] = useState(false);
  const toggleNewCheckIn = () => setModalState(!modalState);
  return (
    <>
      <StyledButton onClick={toggleNewCheckIn}>{children}</StyledButton>
      <NewCheckInForm isOpen={modalState} toggle={toggleNewCheckIn} defaultClass={defaultClass} />
    </>
  );
}

// todo - do we need defaultClass? was unused
// eric: this is for unimplemented functionality, the select box referred to be classRef should be initially set to defaultClass
const NewCheckInForm = ({ 
  // defaultClass, 
  isOpen, 
  toggle 
}) => {
  const history = useHistory();
  const classRef = useRef();

  const [studentClasses, setStudentClasses] = useState([]);
  const [preferredActivities, setPreferredActivities] = useState([]);

  const selectedActivityChanged = (id, checked) => {
    const newActivities = preferredActivities?.map(activity => {
      let { preferredActivityId } = activity;

      if(preferredActivityId === id) {
        activity.selected = checked;
      }

      return activity;
    });
    
    setPreferredActivities(newActivities);
  };

  const fetchData = async () => {
    // todo - doesn't this have to be .json()'d?
    // eric: the userService has the .json()
    const [activities, profile, studentClasses] = await Promise.all([
      userService.getAvailableActivities(), 
      userService.getProfile(), 
      userService.getClasses()
    ]);

    // todo - find better names for the below function (especially for the comparison - hard to tell whats going on there)
    // eric: there are a list of possible activities (activities) from which the creator of the check-in will select a subset for the students doing a check-in to vote on
    // this code here is "preselecting" the creator's preferred activities

    const preferredActivities = activities?.map(activity => ({ 
      ...activity, 
      selected: profile?.preferredActivities.find(
        ({ preferredActivityId }) => preferredActivityId === activity.preferredActivityId
      ) !== null
    }));

    setPreferredActivities(preferredActivities);
    setStudentClasses(studentClasses);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const addCheckIn = async () => {
    const response = await authorizedPost('api/check-ins', {
      classId: classRef.current?.value,
      checkInActivities: preferredActivities?.filter(({ selected }) => selected)
        .map(({ preferredActivityId }) => ({ preferredActivityId }))
    });
    const { checkInId } = await safeParseResponse(response) || {};
    toggle();
    history.push(`/check-ins/${checkInId}`);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Start a New Check In
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Class</Label>
            <Input innerRef={classRef} type="select">
              {studentClasses.map(({ name: nameOfClass, classId }) =>
                <option value={classId}>{nameOfClass}</option>
              )}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Available Activites</Label>
            {preferredActivities.map(({ name: activityName, selected, preferredActivityId }, i) =>
              <FormGroup check key={i}>
                <Input 
                  id={`preferredCheck${i}`} 
                  type="checkbox" 
                  onChange={e => selectedActivityChanged(preferredActivityId, e.target?.checked)} 
                  checked={selected} 
                />
                <Label check for={`preferredCheck${i}`}>{activityName}</Label>
              </FormGroup>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <StyledButton onClick={addCheckIn}>Create</StyledButton>
        <StyledButton onClick={toggle}>Cancel</StyledButton>
      </ModalFooter>
    </Modal>
  );
}

export default NewCheckInForm;